import './app-legacy';
import { NewCoreModule } from '@new-core/app/scripts/app';

// the ng11 part:
import { NgModule, DoBootstrap, NgZone } from '@angular/core';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { UpgradeModule } from '@angular/upgrade/static';
import { BrowserModule } from '@angular/platform-browser';

import '../styles/app.scss';

import { components } from './components';

@NgModule({
  declarations: components,
  imports: [BrowserModule, UpgradeModule, NewCoreModule],
})
export class GateUpgradedApp implements DoBootstrap {
  constructor(
    private readonly upgrade: UpgradeModule,
    private ngZone: NgZone,
  ) {}

  ngDoBootstrap() {
    // NOTE! it uses *timeout* as *interval* - ie it's called onces, instead of
    // all the time
    const zonedInterval = window.setTimeout,
      zonedTimeout = window.setTimeout;

    // TODO find less hacky way to create interval that are not forcing
    // protractor to never ending wait
    // @ts-ignore
    window.setInterval = (a, b) => {
      this.ngZone.runOutsideAngular(() => {
        zonedInterval(a, b);
      });
    };

    // TODO find less hacky way to create interval that are not forcing
    // protractor to never ending wait
    // @ts-ignore
    window.setTimeout = (a, b) => {
      this.ngZone.runOutsideAngular(() => {
        zonedTimeout(a, b);
      });
    };

    // eslint-disable-next-line angular/document-service
    this.upgrade.bootstrap(document.body, ['gateApp'], { strictDi: true });
  }
}

platformBrowserDynamic().bootstrapModule(GateUpgradedApp);
